import type { RouteLocationNamedRaw } from 'vue-router'
import type { ApplicationLifecycleStatus } from '@staff/shared'
import type { ApplicationType } from '@/services/application'
import { isCommitmentApplication } from '@/utils/applicationDisplay'

type ApplicationRouteTarget = {
  id: string
  type: ApplicationType
  status?: ApplicationLifecycleStatus
}

export const applicationRouteLocation = ({ id, type, status }: ApplicationRouteTarget) => {
  const isDraft = status === 'draft'
  const commitment = isCommitmentApplication(type)

  return {
    name: commitment ? (isDraft ? 'nytt-lofte-utkast' : 'lofte') : isDraft ? 'ny-ansokan-utkast' : 'ansokan',
    params: { id },
  } satisfies RouteLocationNamedRaw
}
